import { render, staticRenderFns } from "./BusPolicyForm.vue?vue&type=template&id=05992c4e&scoped=true"
import script from "./BusPolicyForm.vue?vue&type=script&lang=js"
export * from "./BusPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05992c4e",
  null
  
)

export default component.exports